import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { validateForm, validation } from '../../../utils/validation';
import {} from '../../../services/apis';
import { Input, ValidationMessage } from '../../../component';

const CommonTransportationFields = ({
  intl = {},
  language = { name: 'en', direction: 'ltr' },
  transportationData = {},
  setFieldValid = () => {},
  setToastify = () => {},
  onChange = () => {},
}) => {
  const [transportProviderFa, setTransportProviderFa] = useState('');
  const [transportProviderEn, setTransportProviderEn] = useState('');
  const [originTerminalFa, setOriginTerminalFa] = useState('');
  const [originTerminalEn, setOriginTerminalEn] = useState('');
  const [arrivalTerminalFa, setArrivalTerminalFa] = useState('');
  const [arrivalTerminalEn, setArrivalTerminalEn] = useState('');
  const [vehicleNameFa, setVehicleNameFa] = useState('');
  const [vehicleNameEn, setVehicleNameEn] = useState('');
  const [errors, setErrors] = useState({
    transportProviderFa: [],
    transportProviderEn: [],
    originTerminalFa: [],
    originTerminalEn: [],
    arrivalTerminalFa: [],
    arrivalTerminalEn: [],
    vehicleNameFa: [],
    vehicleNameEn: [],
  });

  // start life cycle
  useEffect(() => {
    const { originTerminal, arrivalTerminal, transportProvider, vehicleName } =
      transportationData;
    setTransportProviderFa(transportProvider?.name?.fa);
    setTransportProviderEn(transportProvider?.name?.en);
    setOriginTerminalFa(originTerminal?.name?.fa);
    setOriginTerminalEn(originTerminal?.name?.en);
    setArrivalTerminalFa(arrivalTerminal?.name?.fa);
    setArrivalTerminalEn(arrivalTerminal?.name?.en);
    setVehicleNameFa(vehicleName?.name?.fa);
    setVehicleNameEn(vehicleName?.name?.en);
    setErrors({
      transportProviderFa: [],
      transportProviderEn: [],
      originTerminalFa: [],
      originTerminalEn: [],
      arrivalTerminalFa: [],
      arrivalTerminalEn: [],
      vehicleNameFa: [],
      vehicleNameEn: [],
    });
  }, [transportationData]);
  useEffect(() => {
    const { result } = handleValidation();
    if (result) onChange(generateTransportationDataObject());
    setFieldValid(result);
  }, [
    transportProviderFa,
    transportProviderEn,
    originTerminalFa,
    originTerminalEn,
    arrivalTerminalFa,
    arrivalTerminalEn,
    vehicleNameFa,
    vehicleNameEn,
  ]);
  // end life cycle

  // start others
  const handleValidation = () => {
    const { error, result } = validateForm({
      transportProviderFa: validation?.persian(transportProviderFa)?.required()
        ?.errors,
      transportProviderEn: validation?.english(transportProviderEn)?.required()
        ?.errors,
      originTerminalFa: validation?.persian(originTerminalFa)?.optional()
        ?.errors,
      originTerminalEn: validation?.english(originTerminalEn)?.optional()
        ?.errors,
      arrivalTerminalFa: validation?.persian(arrivalTerminalFa)?.optional()
        ?.errors,
      arrivalTerminalEn: validation?.english(arrivalTerminalEn)?.optional()
        ?.errors,
      vehicleNameFa: validation?.persian(vehicleNameFa)?.required()?.errors,
      vehicleNameEn: validation?.english(vehicleNameEn)?.required()?.errors,
    });
    return { error, result };
  };
  const generateTransportationDataObject = () => {
    return {
      originTerminal: {
        name: { fa: originTerminalFa, en: originTerminalEn },
        _id: '',
      },
      arrivalTerminal: {
        name: { fa: arrivalTerminalFa, en: arrivalTerminalEn },
        _id: '',
      },
      transportProvider: {
        name: { fa: transportProviderFa, en: transportProviderEn },
        _id: '',
      },
      vehicleName: { name: { fa: vehicleNameFa, en: vehicleNameEn }, _id: '' },
    };
  };
  return (
    <>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="transportProviderFa"
          label={`${intl.formatMessage({
            id: 'tour.transportproviderlocal',
          })}`}
          value={transportProviderFa}
          onChange={({ target: { value } }) => {
            setTransportProviderFa(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  transportProviderFa: validation?.persian(value)?.required()
                    .errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.transportProviderFa} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="transportProviderEn"
          label={`${intl.formatMessage({
            id: 'tour.transportprovideren',
          })}`}
          value={transportProviderEn}
          onChange={({ target: { value } }) => {
            setTransportProviderEn(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  transportProviderEn: validation?.english(value)?.required()
                    .errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.transportProviderEn} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="vehicleNameFa"
          label={`${intl.formatMessage({
            id: 'tour.vehiclenamefa',
          })}`}
          value={vehicleNameFa}
          onChange={({ target: { value } }) => {
            setVehicleNameFa(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  vehicleNameFa: validation.persian(value).required().errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.vehicleNameFa} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="vehicleNameEn"
          label={`${intl.formatMessage({
            id: 'tour.vehiclenameen',
          })}`}
          value={vehicleNameEn}
          onChange={({ target: { value } }) => {
            setVehicleNameEn(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  vehicleNameEn: validation.english(value).required().errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.vehicleNameEn} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="originTerminalFa"
          label={`${intl.formatMessage({
            id: 'tour.originterminalfa',
          })}`}
          value={originTerminalFa}
          onChange={({ target: { value } }) => {
            setOriginTerminalFa(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  originTerminalFa: validation.persian(value).optional().errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.originTerminalFa} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="originTerminalEn"
          label={`${intl.formatMessage({
            id: 'tour.originterminalen',
          })}`}
          value={originTerminalEn}
          onChange={({ target: { value } }) => {
            setOriginTerminalEn(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  originTerminalEn: validation.english(value).optional().errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.originTerminalEn} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="arrivalTerminalFa"
          label={`${intl.formatMessage({
            id: 'tour.destinationterminalfa',
          })}`}
          value={arrivalTerminalFa}
          onChange={({ target: { value } }) => {
            setArrivalTerminalFa(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  arrivalTerminalFa: validation.any(value).optional().errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.arrivalTerminalFa} />
      </fieldset>
      <fieldset className="col-sm-6 col-12 mt-3">
        <Input
          name="arrivalTerminalEn"
          label={`${intl.formatMessage({
            id: 'tour.destinationterminalen',
          })}`}
          value={arrivalTerminalEn}
          onChange={({ target: { value } }) => {
            setArrivalTerminalEn(value),
              setErrors((errors) => {
                return {
                  ...errors,
                  arrivalTerminalEn: validation.any(value).optional().errors,
                };
              });
          }}
          outSideLabelClass="text-start"
          outSideLabelPosition="top"
          outSideLabel={true}
          themeMode="light"
        />
        <ValidationMessage errors={errors.arrivalTerminalEn} />
      </fieldset>
    </>
  );
};

CommonTransportationFields.propTypes = {
  intl: PropTypes.object,
  language: PropTypes.object,
  transportationData: PropTypes.object,
  setFieldValid: PropTypes.func,
  setToastify: PropTypes.func,
  onChange: PropTypes.func,
};

export default CommonTransportationFields;
